import { Component, NgZone, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { of, interval } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from 'src/app/core/services/token.service';
import { LocalStorage } from 'src/app/core/localstorage';

import { LanguageService } from 'src/app/core/services/language.service';
import { LANGUAGES } from 'src/app/core/constants';
import { UserService } from 'src/app/modules/user/user.service';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    form: FormGroup;
    loading: boolean = false;

    /* Alerta de erro e sucesso */
    alert = {
        show: false,
        message: '',
        type: 'success',
    };

    get controls() {
        return this.form.controls;
    }

    redirectRoute: string;

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private localStorage: LocalStorage,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private languageService: LanguageService,
        private title: Title,
        private setupService: SetupService,
        private ngZone: NgZone
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required],
            recaptcha: [null, Validators.required],
        });

        const { email } = this.route.snapshot.queryParams;
        if (!!email) {
            this.form.patchValue({ email });
        }
        this.title.setTitle(`Login - ${this.setupService.title}`);
        this.redirectRoute = this.route.snapshot.queryParamMap.get('redirect');
    }

    login() {
        this.authService.login(this.form.value).subscribe(
            (returnSuccess) => this.successCallbackApi(returnSuccess),
            (returnFail) => this.errorCallbackServer(returnFail)
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    async successCallbackApi(response: any) {
        // - EXIBIR ALERTA
        this.alert.message = response.description;
        this.alert.show = true;
        this.alert.type = 'success';
        // - TRATAR ERRO
        if (response.status_code !== 0) {
            this.errorCallbackServer(response);
            return;
        }

        // - SETAR TOKEN
        this.localStorage.saveToken(response.token);
        // - REDIRECIONAR APÓS DELAY
        await this.delay().toPromise();

        // - SALVAR USER NO LOCALSTORAGE
        // this.userService.currentUser.next(response.registers.usuario);
        this.userService.saveUserToLocalStorage(response.registers.usuario);

        this.ngZone.run(() => {
            if (!!this.redirectRoute) {
                this.router.navigate([this.redirectRoute]);
            } else {
                this.router.navigate(['/home']);
            }
        });
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        // TODO:
        // - EXIBIR ALERTA ERRO
        // - LIMPAR CAMPO SENHA
        this.alert.type = 'danger';
        this.form.controls.password.reset();
    }

    delay() {
        return of(1).pipe(delay(1000));
    }
}
